import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from '../components';

export const REQUIRED_BEFORE_CONTINUING = 'Required before continuing';

export default function AttestationCheckbox({
  id, name, checked, onChange, error, errorText = REQUIRED_BEFORE_CONTINUING, children,
}) {
  return (
    <Flex style={{ backgroundColor: '#F3FAFF', padding: '20px' }}>
      <input
        style={{
          marginRight: '12px',
          width: '20px',
          height: '20px',
          flex: '0 0 20px',
        }}
        type="checkbox"
        name={name}
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <Text fontWeight="bold" fontSize="14px" lineHeight="25px" marginTop="-6px">
        <label htmlFor={id} style={{ cursor: 'pointer' }}>
          {children}
        </label>
        <br />
        {error && (
          <span
            role="alert"
            style={{ color: '#FF7152', marginTop: '8px', marginLeft: '-16px' }}
          >
            {errorText}
          </span>
        )}
      </Text>
    </Flex>
  );
}

AttestationCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  children: PropTypes.node,
};

AttestationCheckbox.defaultProps = {
  error: false,
  errorText: REQUIRED_BEFORE_CONTINUING,
  children: null,
};
